import React from 'react'
import PropTypes from 'prop-types';

import Label from './label';

class Error extends React.Component {
    static propTypes = {
        message: PropTypes.string.isRequired
    }

    render() {
        const {printable, message} = this.props;
        return <div className="error">
            <Label className="error">{message}</Label>
        </div>
    }
}



export default Error;
